// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background {
  background: #eeeeee;
  min-height: 450px;
  padding: 42px 24px 56px;
  width: 100%;
}

.learn-more-shell {
  background: #ffffff;
  margin: 0 auto;
  max-width: 1120px;
  padding: 42px 44px 54px;
}

.learn-more-back-button {
  align-items: center;
  background: #cc0000;
  border: 0;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 700;
  gap: 8px;
  min-height: 40px;
  padding: 0 16px;
  transition: background-color 160ms ease;
}

.learn-more-back-button:hover {
  background: #a90000;
}

.learn-more-back-button:focus-visible {
  outline: 3px solid rgba(66, 126, 147, 0.35);
  outline-offset: 3px;
}

.learn-more-titlebar {
  margin: 26px 0 34px;
  text-align: center;
}

.learn-more-header {
  color: #12394d;
  font-family: "Roboto-Slab", "Roboto Slab", serif;
  font-size: clamp(42px, 4.4vw, 56px);
  font-weight: 700;
  line-height: 1.05;
  margin: 0;
}

.line {
  background-color: #d9d9d9;
  border: 0;
  height: 4px;
  margin: 24px auto 0;
  width: 92px;
}

.learn-more-feature-image,
.support-image {
  margin: 0;
  overflow: hidden;
}

.learn-more-feature-image {
  align-self: start;
  max-height: 360px;
}

.image {
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  width: 100%;
}

.archive-story-section {
  align-items: start;
  display: grid;
  gap: 42px;
  grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.85fr);
  padding-top: 10px;
}

.archive-story-copy {
  display: grid;
  gap: 22px;
}

.paragraph {
  color: #222222;
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  line-height: 1.7;
  margin: 0;
  text-align: left;
}

.paragraph a {
  color: #cc0000;
  font-weight: 700;
}

.section-heading h2,
.support-copy h2 {
  color: #12394d;
  font-family: "Roboto-Slab", "Roboto Slab", serif;
  font-size: clamp(26px, 2.6vw, 34px);
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}

.videos {
  display: grid;
  gap: 26px;
  margin-top: 62px;
  max-width: none;
}

.section-heading {
  margin-bottom: 22px;
}

.video-grid {
  display: grid;
  align-items: start;
  gap: 26px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.video-block {
  background: #ffffff;
  border-bottom: 3px solid #e0e0e0;
  overflow: hidden;
}

.iframe-container {
  background: #000000;
  width: 100%;
}

.iframe-container iframe {
  aspect-ratio: 16 / 9;
  border: 0;
  display: block;
  height: auto;
  width: 100%;
}

.section-title {
  color: #12394d;
  font-family: "Roboto-Slab", "Roboto Slab", serif;
  font-size: 23px;
  font-weight: 500;
  line-height: 1.25;
  margin: 0 0 14px;
  min-height: 58px;
  padding: 0;
}

.support-section {
  align-items: start;
  border-top: 1px solid #e4e4e4;
  display: grid;
  gap: 32px;
  grid-template-columns: minmax(260px, 0.55fr) minmax(0, 1fr);
  margin-top: 58px;
  padding-top: 42px;
}

.support-image {
  max-height: 220px;
}

.support-copy {
  display: grid;
  gap: 16px;
}

.faq-list {
  display: grid;
  gap: 24px;
  margin: 0 auto;
  max-width: 860px;
}

.faq-item {
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 24px;
}

.faq-item h2 {
  color: #12394d;
  font-family: "Roboto-Slab", "Roboto Slab", serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.25;
  margin: 0 0 10px;
}

@media (prefers-reduced-motion: reduce) {
  .learn-more-back-button {
    transition: none;
  }
}

@media (max-width: 1000px) {
  .learn-more-shell {
    padding: 34px 28px;
  }

  .archive-story-section,
  .support-section {
    grid-template-columns: 1fr;
  }

  .learn-more-feature-image {
    max-height: 360px;
  }

  .video-grid {
    grid-template-columns: 1fr;
  }

  .section-title {
    min-height: 0;
  }
}

@media (max-width: 700px) {
  .background {
    padding: 22px 14px 36px;
  }

  .learn-more-shell {
    padding: 24px 18px;
  }

  .learn-more-header {
    font-size: clamp(34px, 11vw, 46px);
  }

  .archive-story-section {
    gap: 28px;
  }

  .paragraph {
    font-size: 16px;
    line-height: 1.65;
  }

  .support-section {
    padding-top: 32px;
  }

  .support-section {
    margin-top: 42px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/learn-more.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,8DAA8D;EAC9D,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gDAAgD;EAChD,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".background {\n  background: #eeeeee;\n  min-height: 450px;\n  padding: 42px 24px 56px;\n  width: 100%;\n}\n\n.learn-more-shell {\n  background: #ffffff;\n  margin: 0 auto;\n  max-width: 1120px;\n  padding: 42px 44px 54px;\n}\n\n.learn-more-back-button {\n  align-items: center;\n  background: #cc0000;\n  border: 0;\n  color: #ffffff;\n  cursor: pointer;\n  display: inline-flex;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  gap: 8px;\n  min-height: 40px;\n  padding: 0 16px;\n  transition: background-color 160ms ease;\n}\n\n.learn-more-back-button:hover {\n  background: #a90000;\n}\n\n.learn-more-back-button:focus-visible {\n  outline: 3px solid rgba(66, 126, 147, 0.35);\n  outline-offset: 3px;\n}\n\n.learn-more-titlebar {\n  margin: 26px 0 34px;\n  text-align: center;\n}\n\n.learn-more-header {\n  color: #12394d;\n  font-family: \"Roboto-Slab\", \"Roboto Slab\", serif;\n  font-size: clamp(42px, 4.4vw, 56px);\n  font-weight: 700;\n  line-height: 1.05;\n  margin: 0;\n}\n\n.line {\n  background-color: #d9d9d9;\n  border: 0;\n  height: 4px;\n  margin: 24px auto 0;\n  width: 92px;\n}\n\n.learn-more-feature-image,\n.support-image {\n  margin: 0;\n  overflow: hidden;\n}\n\n.learn-more-feature-image {\n  align-self: start;\n  max-height: 360px;\n}\n\n.image {\n  display: block;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n  width: 100%;\n}\n\n.archive-story-section {\n  align-items: start;\n  display: grid;\n  gap: 42px;\n  grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.85fr);\n  padding-top: 10px;\n}\n\n.archive-story-copy {\n  display: grid;\n  gap: 22px;\n}\n\n.paragraph {\n  color: #222222;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 18px;\n  line-height: 1.7;\n  margin: 0;\n  text-align: left;\n}\n\n.paragraph a {\n  color: #cc0000;\n  font-weight: 700;\n}\n\n.section-heading h2,\n.support-copy h2 {\n  color: #12394d;\n  font-family: \"Roboto-Slab\", \"Roboto Slab\", serif;\n  font-size: clamp(26px, 2.6vw, 34px);\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 0;\n}\n\n.videos {\n  display: grid;\n  gap: 26px;\n  margin-top: 62px;\n  max-width: none;\n}\n\n.section-heading {\n  margin-bottom: 22px;\n}\n\n.video-grid {\n  display: grid;\n  align-items: start;\n  gap: 26px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.video-block {\n  background: #ffffff;\n  border-bottom: 3px solid #e0e0e0;\n  overflow: hidden;\n}\n\n.iframe-container {\n  background: #000000;\n  width: 100%;\n}\n\n.iframe-container iframe {\n  aspect-ratio: 16 / 9;\n  border: 0;\n  display: block;\n  height: auto;\n  width: 100%;\n}\n\n.section-title {\n  color: #12394d;\n  font-family: \"Roboto-Slab\", \"Roboto Slab\", serif;\n  font-size: 23px;\n  font-weight: 500;\n  line-height: 1.25;\n  margin: 0 0 14px;\n  min-height: 58px;\n  padding: 0;\n}\n\n.support-section {\n  align-items: start;\n  border-top: 1px solid #e4e4e4;\n  display: grid;\n  gap: 32px;\n  grid-template-columns: minmax(260px, 0.55fr) minmax(0, 1fr);\n  margin-top: 58px;\n  padding-top: 42px;\n}\n\n.support-image {\n  max-height: 220px;\n}\n\n.support-copy {\n  display: grid;\n  gap: 16px;\n}\n\n.faq-list {\n  display: grid;\n  gap: 24px;\n  margin: 0 auto;\n  max-width: 860px;\n}\n\n.faq-item {\n  border-bottom: 1px solid #e4e4e4;\n  padding-bottom: 24px;\n}\n\n.faq-item h2 {\n  color: #12394d;\n  font-family: \"Roboto-Slab\", \"Roboto Slab\", serif;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.25;\n  margin: 0 0 10px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .learn-more-back-button {\n    transition: none;\n  }\n}\n\n@media (max-width: 1000px) {\n  .learn-more-shell {\n    padding: 34px 28px;\n  }\n\n  .archive-story-section,\n  .support-section {\n    grid-template-columns: 1fr;\n  }\n\n  .learn-more-feature-image {\n    max-height: 360px;\n  }\n\n  .video-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .section-title {\n    min-height: 0;\n  }\n}\n\n@media (max-width: 700px) {\n  .background {\n    padding: 22px 14px 36px;\n  }\n\n  .learn-more-shell {\n    padding: 24px 18px;\n  }\n\n  .learn-more-header {\n    font-size: clamp(34px, 11vw, 46px);\n  }\n\n  .archive-story-section {\n    gap: 28px;\n  }\n\n  .paragraph {\n    font-size: 16px;\n    line-height: 1.65;\n  }\n\n  .support-section {\n    padding-top: 32px;\n  }\n\n  .support-section {\n    margin-top: 42px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
